import { createSelector } from "reselect";
import { values } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => state.data.height;

const getHeight = createSelector(getData, height => values(height));

export default getHeight;



// WEBPACK FOOTER //
// ./src/_selectors/dataSelectors/getHeight.js